module.exports = __webpack_public_path__ + "img/dd-logo-hyundai-w.1d152452.png";